import { CDN_CLRSAVE_URL } from '../../constants';
import amcStyles from '../../styles/amcs.scss';
import { Component } from 'react';

class AmcsList extends Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const { amcList, parts } = this.props;
    return (
      <div className="lil-flex lil-flex-wrap lil-pt-6 lil-items-center sm:lil-items-start">
        {amcList.map(list => (
          <div
            className={`lil-w-1/${parts} lil-pr-2 lil-pb-4 md:lil-pr-4 sm:lil-w-full sm:lil-pb-2`}
            key={list.id}
          >
            <a
              className="lil-w-full hover:lil-no-underline"
              href={`/mutual-funds/${list.slug}`}
            >
              <div className="lil-py-4 lil-flex lil-items-center lil-px-2 lil-rounded-xxl lil-shadow-md lg:lil-p-4 ">
                <div className="lil-w-1/6">
                  <img
                    className="lil-rounded-md"
                    width="28"
                    src={`${CDN_CLRSAVE_URL}/clearsave${list.logoImgUrl}`}
                    alt=""
                  />
                </div>
                <div
                  className={`lil-w-5/6 lil-pl-1 ${amcStyles['ellipsisText']}`}
                >
                  <span className="lil-text-s-14 lil-font-semibold">
                    {list.issuingAuthority.toUpperCase()}
                  </span>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    );
  }
}

export default AmcsList;



// WEBPACK FOOTER //
// ./components/common/amcsList.tsx